import { push } from 'connected-react-router'
import dashboardApi from 'services/api/dashboard'

import {
  GET_ARRIVALS_FAILED,
  GET_ARRIVALS_STARTED,
  GET_ARRIVALS_SUCCESS,
  POST_GUEST_FOR_CHAT_FAILED,
  POST_GUEST_FOR_CHAT_INITIATED,
  POST_GUEST_FOR_CHAT_STARTED,
  POST_GUEST_FOR_CHAT_SUCCESS
} from './actionTypes'
import { getChats } from './messaging'

export const getArrivals = () => {
  return async dispatch => {
    dispatch({
      type: GET_ARRIVALS_STARTED
    })

    try {
      const response = await dashboardApi.getArrivals()
      dispatch({
        type: GET_ARRIVALS_SUCCESS,
        payload: response
      })
    } catch (err) {
      dispatch({
        type: GET_ARRIVALS_FAILED,
        payload: err
      })
    }
  }
}

export const postNewGuest = guestInfo => {
  return async dispatch => {
    dispatch({
      type: POST_GUEST_FOR_CHAT_STARTED
    })

    try {
      const response = await dashboardApi.postNewGuestForChat({
        ...guestInfo,
        roomNumber: guestInfo.roomNumber || 'N/A'
      })
      dispatch({
        type: POST_GUEST_FOR_CHAT_INITIATED,
        payload: { ...response, ...guestInfo }
      })

      dispatch({
        type: POST_GUEST_FOR_CHAT_SUCCESS,
        payload: { ...response, ...guestInfo }
      })

      if (response.chatId) {
        dispatch(push(`/messaging/${response.chatId}`))
      }

      dispatch(getChats('service'))
    } catch (err) {
      dispatch({
        type: POST_GUEST_FOR_CHAT_FAILED,
        payload: err
      })
    }
  }
}
